export type ProviderSaid = { company: string; product: string | null; mark: string | null };

const BY_COLUMN: Record<string, ProviderSaid> = {
  openai: { company: "OpenAI", product: null, mark: "openai" },
  "openai-codex": { company: "OpenAI", product: "Codex", mark: "openai" },
  anthropic: { company: "Anthropic", product: "Claude", mark: "anthropic" },
  google: { company: "Google", product: "Gemini", mark: "google" },
  openrouter: { company: "OpenRouter", product: null, mark: "openrouter" },
  venice: { company: "Venice", product: null, mark: "venice" },
  "z-ai": { company: "Z.ai", product: "GLM", mark: null },
};

export function providerSaid(column: string): ProviderSaid {
  const known = BY_COLUMN[column];
  if (known) return known;
  return { company: column, product: null, mark: null };
}

export function providerLine(column: string): string {
  const said = providerSaid(column);
  return said.product ? `${said.company} \u00b7 ${said.product}` : said.company;
}
